import { useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';

export const MetaTags = () => {
  const { translations, language } = useLanguage();

  useEffect(() => {
    // Actualizar el meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', translations.meta.description);
    }

    // Actualizar el título
    document.title = translations.meta.title;

    // Actualizar el atributo lang del HTML
    document.documentElement.lang = language;
  }, [translations, language]);

  return null;
};

